import { render } from "./instagramPreview.vue?vue&type=template&id=63c90ec9&scoped=true"
import script from "./instagramPreview.vue?vue&type=script&lang=js"
export * from "./instagramPreview.vue?vue&type=script&lang=js"

import "./instagramPreview.vue?vue&type=style&index=0&id=63c90ec9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c90ec9"]])

export default __exports__